import { moveToFulfilled, moveToPending, moveToRejected } from '@ms/yammer-data-support';
import type { Reducer } from 'redux';

import type {
  ClientSharePointWebLinkAttachmentEmbedLoadFulfilledAction,
  ClientSharePointWebLinkAttachmentEmbedLoadPendingAction,
  ClientSharePointWebLinkAttachmentEmbedLoadRejectedAction,
} from '../../domains/resolveClientSharePointWebLink/actions.types';

import type { ClientSharePointWebLinkEmbeds } from './types';

export type ClientSharePointWebLinkAction =
  | ClientSharePointWebLinkAttachmentEmbedLoadFulfilledAction
  | ClientSharePointWebLinkAttachmentEmbedLoadPendingAction
  | ClientSharePointWebLinkAttachmentEmbedLoadRejectedAction;

const initialState: ClientSharePointWebLinkEmbeds = {
  pending: { byId: {} },
  fulfilled: { byId: {} },
  rejected: { byId: {} },
};

const reducer: Reducer<ClientSharePointWebLinkEmbeds, ClientSharePointWebLinkAction> = (
  state = initialState,
  action
) => {
  switch (action.type) {
    case 'SHAREPOINT_WEBLINK_EMBED.LOAD_REJECTED':
      return moveToRejected(state, [action.payload.id], action.payload.error);
    case 'SHAREPOINT_WEBLINK_EMBED.LOAD_PENDING':
      return moveToPending(state, [action.payload.id]);
    case 'SHAREPOINT_WEBLINK_EMBED.LOAD_FULFILLED':
      return moveToFulfilled(state, {
        [action.payload.clientSharePointWebLinkEmbed.id]: action.payload.clientSharePointWebLinkEmbed,
      });
    default:
      return state;
  }
};

export default reducer;
